module.exports = __webpack_public_path__ + "img/404.2225d8b5.png";